import { createApp } from 'vue';
import App from './App.vue';
const app = createApp(App);
import {clickOutDirective} from '@/commons/directives/clickoutside.js'

// import 'vue-toast-notification/dist/theme-sugar.css';

//Add extension
import './commons/prototype';
import { initClosePopupOnScroll } from '@/commons/closePopupOnScroll';

// Globally Registered Components
import { useComponents } from '@/commons/globalComponents.js';
useComponents(app);

//phím tắt
import { shortKey } from '@/commons/directives/shortkey.js';
app.directive('shortkey', shortKey);

// Globally Registered Components
import { pluginInstall } from '@/commons/globalPlugin.js';
pluginInstall(app);

//Đăng ký popup
import { register } from '@/commons/globalPopup.js';
register(app);

// Scroll page/container -> đóng mọi dropdown/popup đang mở (Quasar reposition không theo scroller nội bộ)
initClosePopupOnScroll();

// filter
import { initFilter } from './commons/msFormat';
initFilter(app);

// Styles: SCSS
import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import '@/assets/scss/scroller.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/icons.scss';
import '@/assets/scss/btn.scss';
import '@/assets/scss/form.scss';
import '@/assets/scss/app.scss';
import '@/assets/scss/main-style.scss';
import '@/commons/extension-method';

app.config.productionTip = false;

// Vue.config.errorHandler = log.handleGlobalException;
if (process.env.NODE_ENV == 'development') {
  app.config.performance = true;
}

/**
 * directive xử lý style.visibility
 */
app.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});
//add directive
app.directive('click-out',clickOutDirective)

//Khai báo router
import router from '@/routers/router';
app.use(router);

//Khai báo store
import store from '@/stores/store';
app.use(store);

//Sử dụng localize
import i18n from '@/i18ns/i18n';
app.use(i18n);

import { PromiseDialog } from 'vue3-promise-dialog';
app.use(PromiseDialog);

import { Quasar } from 'quasar';

// Import icon libraries
import '@quasar/extras/material-icons/material-icons.css';

// Import Quasar css
import 'quasar/src/css/index.sass';



app.use(Quasar, {
  plugins: {}, // import Quasar plugins and add here
});

const siteKey = '6LeC3rUcAAAAAPhQKasimcypruie-muoSFn6SBOH';
//Inport VueReCaptcha
import { VueReCaptcha, useReCaptcha } from 'vue-recaptcha-v3';
app.use(VueReCaptcha, { siteKey: siteKey });

import filters from '@/commons/filters';
app.config.globalProperties.$filters = filters;

import webSocket from './sockets/socket';
app.config.globalProperties.$signal = webSocket;
// import money from 'v-money'
// app.use(money);



app.mount('#app');
